import { DateTime } from 'luxon';
import 'intersection-observer';
import * as R from 'ramda';

const diffTimes = (dtStart, dtEnd, resolution = 'seconds') => ( 
	dtEnd.diff(dtStart, [resolution]).toObject()[resolution]
);

const agendaLabelFormat = dt => dt.toLocaleString(DateTime.DATETIME_MED);
const agendaLabelFormatTime = dt => dt.toLocaleString(DateTime.TIME_SIMPLE);

const isPositive = x => x >= 0;

const addViewportPosition = (item) => ({
	...item,
	viewportY: item.element.getBoundingClientRect().top
});

const ratioSort = R.sortWith([
	R.descend(R.prop('ratio')),
	// R.descend(R.prop('startTime'))
	R.ascend(R.prop('startTime'))
]);

const viewportSort = R.sortWith([
	R.ascend(R.prop('viewportY'))
]);

export default function agendaTimelineAnimation(timeGroupElements, dateInfo){

	const timeGroups = {};
	const intersections = new Set();
	timeGroupElements.forEach((el) => {
		const id = el.getAttribute('id');

		const startTime = el.getAttribute('data-start-time');
		const endTime = el.getAttribute('data-end-time');
		const date = el.getAttribute('data-date');
		
		timeGroups[id] = {
			id,
			startTime,
			endTime,
			date,
			element: el,
			intersecting: false,
			startObserver() {
				const dateTimeSessionStart = DateTime.fromSQL(`${date} ${startTime}`);
				const dateTimeSessionEnd = DateTime.fromSQL(`${date} ${endTime}`);
				this.startLabel = agendaLabelFormatTime(dateTimeSessionStart);
				const length = diffTimes(dateTimeSessionStart, dateTimeSessionEnd);

				const info = dateInfo[date];
				this.firstSession = info.start === startTime;
				const dateTimeDayStart = DateTime.fromSQL(`${date} ${info.start}`)
				const dateTimeDayEnd = DateTime.fromSQL(`${date} ${info.end}`)
				this.dayStartLabel = agendaLabelFormatTime(dateTimeDayStart);
				this.dayEndLabel = agendaLabelFormatTime(dateTimeDayEnd)

				const dayInSeconds = diffTimes(dateTimeDayStart, dateTimeDayEnd);
				const secondsFromStart = diffTimes(dateTimeDayStart, dateTimeSessionStart);
				this.percFromStart = secondsFromStart / dayInSeconds * 100;

				const timelineSel = `.timeline-container[data-day="${date}"]`;
				this.timelineDayStartEl = document.querySelector(`${timelineSel} .day-start`);
				this.timelineDayEndEl = document.querySelector(`${timelineSel} .day-end`);
				this.markerEl = document.querySelector(`${timelineSel} .marker`);
				this.markerElSpan = document.querySelector(`${timelineSel} .marker span`)

				this.percOfDay = length / dayInSeconds * 100;

				this.observer = new IntersectionObserver(
					([entry]) => {
						this.ratio = entry.intersectionRatio;
						if (entry.isIntersecting) {
							this.intersecting = true;
							intersections.add(this);
						}
						else {
							this.intersecting = false;
							intersections.delete(this);
						}					
						updateTimeline(intersections);
					}, {
						rootMargin: '-100px',
						threshold: [0, 0.05, 0.2, 0.5, 0.8, 0.95, 1],
						threshold: 0.3,
						root: null
					}
				)
				this.observer.observe(el);
			}
		}
		timeGroups[id].startObserver();
	});



	const setTimelineToSession = (item) => {
		const {
			startLabel,
			timelineDayEndEl,
			timelineDayStartEl,
			markerElSpan,
			markerEl,
			dayStartLabel,
			dayEndLabel,
			firstSession,
			percOfDay,
			percFromStart,
		} = item;
		timelineDayStartEl.innerHTML = dayStartLabel;
		timelineDayEndEl.innerHTML = dayEndLabel;

		markerEl.style.top = `${percFromStart}%`;
		markerEl.style.height = `${percOfDay}%`;
		
		markerElSpan.innerHTML = firstSession ? '' : startLabel;
	}


	const updateTimeline = R.pipe(
		Array.from,
		R.groupBy(R.prop('date')),
		R.values,
		R.map(R.map(addViewportPosition)),
		// R.map(ratioSort),
		// R.map(R.head),
		R.map(viewportSort),
		R.map(list => {
			for (let i = 0; i < list.length; i++) {
				if (list[i].viewportY >= 0) {
					return list[i];
				}
			}
			return list[0];
		}),
		R.forEach(setTimelineToSession)
	);

}